import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { CompanyResolver } from 'src/app/shared/resolvers/company.resolver';
import { EmployeeResolver } from 'src/app/shared/resolvers/employee.resolver';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import { EpochListComponent } from './epoch/epoch-list/epoch-list.component';
import { FamilyListComponent } from './family/family-list/family-list.component';
import { HolidayListComponent } from './holiday/holiday-list/holiday-list.component';
import { EmployeeInsuranceListComponent } from './insurance-employee/employee-insurance-list/employee-insurance-list.component';
import { InsuranceListComponent } from './insurance/insurance-list/insurance-list.component';
import { MediumListComponent } from './medium/medium-list/medium-list.component';
import { MetricsListComponent } from './metrics/metrics-list/metrics-list.component';
import { PerformanceListComponent } from './performance/performance-list/performance-list.component';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';
import { QuarterListComponent } from './quarter/quarter-list/quarter-list.component';
import { RoleListComponent } from './role/role-list/role-list.component';
import { SocialMediaListComponent } from './social/social-media-list/social-media-list.component';
import { TitleListComponent } from './title/title-list/title-list.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { WorkdayListComponent } from './workday/workday-list/workday-list.component';


const routes: Routes = [
  {
    path: 'social-media-list',
    component: SocialMediaListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'social-media-list',
      modules:['SOCIAL MEDIA']
    }
  },
  {
    path: 'metrics-list',
    component: MetricsListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'metrics-list',
      modules:['METRIC']
    }
   
  },
  {
    path: 'performance-list',
    component: PerformanceListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'performance-list',
      modules:['PERFORMANCE']
    }
   
  },
  {
    path: 'employee-insurance-list',
    component: EmployeeInsuranceListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'employee-insurance-list',
      modules:['COVERAGE']
    }
  },
  {
    path: 'insurance-list',
    component: InsuranceListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'insurance-list',
      modules:['INSURANCE']
    }
   
  },
  {
    path: 'company-list',
    component: CompanyListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'company-list',
      modules:['COMPANY']
    }
  },
  {
    path: 'holiday-list',
    component: HolidayListComponent,
    canActivate:[ModuleGuard],
    resolve: { companyId: CompanyResolver },
    data: {
      title: 'holiday-list',
      modules:['HOLIDAY']
    }
  },
  {
    path: 'workday-list',
    canActivate:[ModuleGuard],
    component: WorkdayListComponent,
    data: {
      title: 'workday-list',
      modules:['WORKDAY']
    }
  },
  {
    path: 'role-list',
    canActivate:[ModuleGuard],
    component: RoleListComponent,
    data: {
      title: 'role-list',
      modules:['ROLE']
    }
  },
  {
    path: 'user-list',
    canActivate:[ModuleGuard],
    component: UserListComponent,
    data: {
      title: 'user-list',
      modules:['USER']
    }
  },
  {
    path: 'employee-list',
    canActivate:[ModuleGuard],
    component: EmployeeListComponent,
    data: {
      title: 'employee-list',
      modules:['EMPLOYEE']
    }
  },
  {
    path: 'title-list',
    canActivate:[ModuleGuard],
    component: TitleListComponent,
    data: {
      title: 'title-list',
      modules:['TITLE']
    }
  },
  {
    path: 'social-media',
    component: MediumListComponent,
    canActivate:[ModuleGuard],
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'social-media',
      modules:['SOCIAL MEDIA']
    }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    data: {
      title: 'profile',
    }
  },
  {
    path: 'family-list',
    canActivate:[ModuleGuard],
    component: FamilyListComponent,
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'family',
      modules:['FAMILY'],
      
    }
  },
  {
    path: 'epoch-list',
    canActivate:[ModuleGuard],
    component: EpochListComponent,
    data: {
      title: 'epoch',
      modules:['EPOCH']
    }
  },
  {
    path: 'quarter-list',
    canActivate:[ModuleGuard],
    component: QuarterListComponent,
    data: {
      title: 'quarter',
      modules:['QUARTER']
    }
  },
  {
    path: 'change-password',
    // canActivate:[ModuleGuard],
    component: ChangePasswordComponent,
    data: {
      title: 'change-password',
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SetupRoutingModule { }
